var _rect, _rect2, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 70,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "url(#iconDownloadLinear1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 90,
    width: 54,
    height: 3,
    fill: "url(#iconDownloadLinear2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 29H69V67L84 52L89.5 57.5L65 82L40.5 57.5L46 52L61 67V29Z",
    fill: "url(#iconDownloadLinear3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87H34V96H98V87H106V104H26V87Z",
    fill: "url(#iconDownloadLinear4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconDownloadLinear1",
    x1: 0,
    y1: 0,
    x2: 130,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#F3FFF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconDownloadLinear2",
    x1: 65,
    y1: 0.999998,
    x2: 64.9999,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.548122,
    stopColor: "#94FA91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919048,
    stopColor: "#77BB75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconDownloadLinear3",
    x1: 65,
    y1: 0.499999,
    x2: 65,
    y2: 129.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125985,
    stopColor: "#95EC92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894588,
    stopColor: "#77BB75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconDownloadLinear4",
    x1: 66,
    y1: 27.5,
    x2: 66,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94FA91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77BB75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/iconDownload.a999d0144a58d4916b509051e872f60b.svg";
export { ForwardRef as ReactComponent };